<div class="container-xxl gx-sm-9 gx-lg-10 gx-xxl-0">
    <div class="bg-secondary p-10 p-lg-13 p-xl-14">
        <div class="row gx-0 flex-md-row-reverse mb-8 mb-md-0">
            <div class="col-12 col-md-5 d-flex flex-column justify-content-center px-0 px-lg-12 px-md-7 word-wrap-break-word">
                <h3 class="mb-4 fs-29 fw-700 text-white">{{ 'AWARDED_COLLECTIONS.title' | translate }}</h3>
                <p class="mb-7 lh-29 text-gray-300">{{ 'AWARDED_COLLECTIONS.content' | translate }}</p>
                <div class="d-none d-md-block">
                    <app-button [url]="['.', { snapshot: 'FP-P0MO-QG9J' }]" type="link" color="secondary" type="link">{{
                        'AWARDED_COLLECTIONS.btn' | translate
                    }}</app-button>
                </div>
            </div>
            <div class="col-12 col-md-7">
                <div class="h-100 overflow-hidden">
                    <img class="min-w-100 min-h-100 img-fluid item-md-center" src="/assets/images/awarded_collections_ring.png" alt="" />
                </div>
            </div>
        </div>
        <div class="d-block d-md-none">
            <app-button [url]="['.', { snapshot: 'FP-P0MO-QG9J' }]" color="secondary" type="link">{{ 'AWARDED_COLLECTIONS.btn' | translate }}</app-button>
        </div>
    </div>
</div>
